import { t } from "i18next";

import { FieldBuilder, MultiPageFormBuilder } from "../../formBuilder/index.js";
import { longTextSchema, yesNoSchema } from "../../types/index.js";
import { tk } from "../../types/Translation.js";

export const formSpecification = new MultiPageFormBuilder()
  .withFieldAlwaysVisible({
    fieldName: "accompanyingToEmergencyDepartment",
    type: "radio",
    ...new FieldBuilder().withSchema(yesNoSchema).captureValueLabel().build(),
    label: tk("mcaAccompaniment.accompanyingToEmergencyDepartment"),
    requiredLabel: tk(
      "mcaAccompaniment.accompanyingToEmergencyDepartmentRequired",
    ),
    options: [
      { label: tk("common.yes"), value: "yes" },
      { label: tk("common.no"), value: "no" },
    ],
  })

  .withFieldConditionallyVisible({
    fieldName: "notAccompanyingReason",
    type: "textbox",
    ...new FieldBuilder().withSchema(longTextSchema).build(),
    multiline: true,
    rows: "5",
    label: tk("mcaAccompaniment.notAccompanyingReason"),
    requiredLabel: tk("mcaAccompaniment.notAccompanyingReasonRequired"),
    isVisible: ({ formValues }) =>
      formValues.accompanyingToEmergencyDepartment?.value === "no",
  })

  .withReadonlyFieldConditionallyVisible({
    fieldName: "notAccompanyingInstructionsBanner",
    type: "banner",
    bannerType: "info",
    body: tk("mcaAccompaniment.notAccompanyingInstructionsBanner"),
    isVisible: ({ formValues }) =>
      formValues.accompanyingToEmergencyDepartment?.value === "no",
  })

  .withFieldConditionallyVisible({
    fieldName: "personLeftInCareOf",
    type: "textbox",
    ...new FieldBuilder().withSchema(longTextSchema).build(),
    multiline: true,
    rows: "5",
    label: tk("mcaAccompaniment.personLeftInCareOf"),
    requiredLabel: tk("mcaAccompaniment.personLeftInCareOfRequired"),
    isVisible: ({ formValues }) =>
      formValues.accompanyingToEmergencyDepartment?.value === "no",
  })

  .withReadonlyFieldConditionallyVisible({
    fieldName: "personLeftInCareOfBanner",
    type: "banner",
    bannerType: "info",
    body: tk("mcaAccompaniment.personLeftInCareOfBanner"),
    isVisible: ({ formValues }) =>
      formValues.accompanyingToEmergencyDepartment?.value === "no",
  })

  .withPage([
    "accompanyingToEmergencyDepartment",
    "notAccompanyingReason",
    "notAccompanyingInstructionsBanner",
  ])
  .withPage(["personLeftInCareOf", "personLeftInCareOfBanner"])
  .build({ t });

export type McaAccompanimentFormData = ReturnType<
  typeof formSpecification
>["formType"];
